import * as React from "react";
import {
  Button,
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Text,
} from "@fluentui/react-components";
import { Copy24Regular } from "@fluentui/react-icons";

interface DebugDialogProps {
  debugInfo: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onClear: () => void;
  onCopy: () => void;
}

const DebugDialog: React.FC<DebugDialogProps> = ({ debugInfo, isOpen, onOpenChange, onClear, onCopy }) => {
  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => onOpenChange(data.open)}>
      <DialogTrigger disableButtonEnhancement>
        <Button appearance="secondary" size="small">
          Debug
        </Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Debug Information</DialogTitle>
          <DialogContent>
            <Text style={{ whiteSpace: "pre-wrap", fontSize: "12px" }}>{debugInfo}</Text>
          </DialogContent>
          <DialogActions>
            <Button icon={<Copy24Regular />} onClick={onCopy}>
              Copy
            </Button>
            <Button appearance="primary" onClick={onClear}>
              Clear
            </Button>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">Close</Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default DebugDialog;
